import React, { useState, useEffect, useRef, useMemo } from 'react';

const CLASSES_NCL = [
  '01','02','03','04','05','06','07','08','09','10',
  '11','12','13','14','15','16','17','18','19','20',
  '21','22','23','24','25','26','27','28','29','30',
  '31','32','33','34','35','36','37','38','39','40',
  '41','42','43','44','45',
];

const inp = { width: '100%', padding: '3px 6px', borderRadius: 3, border: '1px solid #b0b8c4', fontSize: 13, color: '#111', boxSizing: 'border-box', background: '#fff', height: 26 };
const lbl = { fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 3 };
const th = { padding: '5px 10px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#fff', textTransform: 'uppercase', letterSpacing: '0.04em', background: '#0a1628', whiteSpace: 'nowrap' };
const td = { padding: '4px 10px', fontSize: 12, color: '#374151', borderBottom: '1px solid #e8eaed' };

function token() { return localStorage.getItem('token'); }

const semStyle = {
  verde:    { background: '#dcfce7', border: '1px solid #86efac', color: '#15803d' },
  amarelo:  { background: '#fef9c3', border: '1px solid #fde047', color: '#854d0e' },
  vermelho: { background: '#fee2e2', border: '1px solid #fca5a5', color: '#991b1b' },
};

// ── Modal de especificações NCL — réplica do "Busca de Especificação de
// Produtos ou Serviços" do sistema de protocolo do INPI (e-Marcas).
// Dados copiados de lá (14.982 itens) e servidos por GET /marcas-rpi/ncl.
const normNcl = s => (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');

// Pinta o trecho que casou com a busca dentro da especifica\u00e7\u00e3o. \u00c9 o que torna
// o filtro audit\u00e1vel: "m\u00f3veis" tamb\u00e9m casa dentro de "autom\u00f3veis", e vendo o
// destaque d\u00e1 pra descartar o falso positivo na hora, sem ler tudo.
function destacar(texto, termo) {
  const t = normNcl((termo || '').trim());
  if (!t) return texto;
  const alvo = normNcl(texto);
  const partes = [];
  let ini = 0, i = alvo.indexOf(t);
  while (i !== -1) {
    if (i > ini) partes.push(texto.slice(ini, i));
    partes.push(<mark key={i} style={{ background: '#fde68a', color: '#78350f', fontWeight: 700, padding: '0 1px', borderRadius: 2 }}>{texto.slice(i, i + t.length)}</mark>);
    ini = i + t.length;
    i = alvo.indexOf(t, ini);
  }
  if (ini < texto.length) partes.push(texto.slice(ini));
  return partes;
}

// ── Especificações LIVRES na classe (16/09) ──────────────────────────────
// Pega a especificação de todos os processos que estão no resultado da tela,
// cruza com a lista padrão NCL da classe e mostra o que NENHUM deles cobre —
// é o mapa do que ainda dá pra pedir sob o princípio da especialidade.
// Item casa por igualdade normalizada (sem acento/caixa, sem o " *" do INPI)
// ou por contenção com 10+ caracteres, o mesmo critério do comparador de
// especificações. Redação livre pode escapar: por isso a aba "Ocupadas"
// mostra quem cobre o quê, pra conferir.
// Parênteses e colchetes caem fora: a lista NCL escreve "[através de qualquer
// meio]" e muita especificação depositada vem "(através de qualquer meio)" —
// sem isso "artigos de ferragem" da CONSTRUR CENTER aparecia como livre.
const normItem = s => normNcl(s).replace(/\s*\*\s*$/, '').replace(/[()[\]]/g, '').replace(/\s+/g, ' ').trim();
const semZero = c => String(parseInt(c, 10) || c);

function ModalEspecificacoesLivres({ onFechar, resultados, classesSel }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  // Classe: a(s) da pesquisa; sem classe na pesquisa, as que aparecem no resultado
  const classesDisp = useMemo(() => {
    if (classesSel && classesSel.length) return classesSel.map(semZero);
    const cont = {};
    for (const r of resultados) for (const c of r.classes || []) { const k = semZero(c.codigo); cont[k] = (cont[k] || 0) + 1; }
    return Object.keys(cont).sort((a, b) => cont[b] - cont[a] || a - b);
  }, [resultados, classesSel]);
  const [classeSel, setClasseSel] = useState(classesDisp[0] || '');
  const [soVivas, setSoVivas] = useState(false);
  const [filtro, setFiltro] = useState('');
  const [aba, setAba] = useState('livres');
  const [marcados, setMarcados] = useState([]);

  useEffect(() => {
    fetch('/marcas-rpi/ncl', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : Promise.reject(new Error('Especificações NCL não disponíveis')))
      .then(setDados).catch(e => setErro(e.message));
  }, []);

  const analise = useMemo(() => {
    const itensNcl = (dados && dados[classeSel] && dados[classeSel].itens) || [];
    const procs = resultados.filter(r => !soVivas || r.situacao === 'Ativa' || r.situacao === 'Em andamento');
    const cobertura = new Map();   // item normalizado → processos que o listam
    const textos = [];             // especificação inteira de cada processo na classe
    let naClasse = 0, semEspec = 0;
    for (const r of procs) {
      for (const c of r.classes || []) {
        if (semZero(c.codigo) !== classeSel) continue;
        naClasse += 1;
        const esp = (c.especificacao || '').trim();
        if (!esp) { semEspec += 1; continue; }
        textos.push({ r, texto: normItem(esp) });
        for (const it of esp.split(';')) {
          const k = normItem(it);
          if (!k) continue;
          if (!cobertura.has(k)) cobertura.set(k, []);
          cobertura.get(k).push(r);
        }
      }
    }
    const unicos = (lista) => { const v = new Set(); return lista.filter(r => !v.has(r.numero) && v.add(r.numero)); };
    const itens = itensNcl.map(txt => {
      const k = normItem(txt);
      let quem = cobertura.get(k) || [];
      let modo = quem.length ? 'exato' : '';
      if (!quem.length && k.length >= 10) {
        quem = textos.filter(t => t.texto.includes(k)).map(t => t.r);
        if (quem.length) modo = 'contido';
      }
      return { txt, quem: unicos(quem), modo };
    });
    return { itens, naClasse, semEspec, totalNcl: itensNcl.length };
  }, [dados, classeSel, resultados, soVivas]);

  const f = normNcl(filtro.trim());
  const livres = analise.itens.filter(a => !a.quem.length && (!f || normNcl(a.txt).includes(f)));
  const ocupadas = analise.itens.filter(a => a.quem.length && (!f || normNcl(a.txt).includes(f)));
  const totalLivres = analise.itens.filter(a => !a.quem.length).length;

  const marcar = txt => setMarcados(p => p.includes(txt) ? p.filter(x => x !== txt) : [...p, txt]);
  const copiar = (lista, rotulo) => {
    const texto = lista.join(';\n') + (lista.length ? ';' : '');
    if (!lista.length) return;
    navigator.clipboard.writeText(texto).then(() => alert(`✅ ${lista.length} especificação(ões) copiada(s) — ${rotulo}.`))
      .catch(() => prompt('Copie abaixo:', texto));
  };

  const btn = (ativo) => ({ background: ativo ? '#0a1628' : '#fff', color: ativo ? '#fff' : '#374151', border: '1px solid #b0b8c4', borderRadius: 4, padding: '3px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' });
  const btnCinza = { background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' };
  const titulo = dados && dados[classeSel] ? dados[classeSel].titulo : '';

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, width: '100%', maxWidth: 1000, height: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>
            🧩 Especificações livres na classe {classeSel}
            <span style={{ fontWeight: 400, opacity: .65, fontSize: 12, marginLeft: 8 }}>
              {dados ? `${totalLivres} de ${analise.totalNcl} itens não aparecem em nenhum dos ${analise.naClasse} processos da classe no resultado` : 'carregando a lista NCL…'}
            </span>
          </span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        {erro && <div style={{ padding: 16, color: '#dc2626', fontSize: 13 }}>⚠ {erro}</div>}
        {!erro && (
          <>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', padding: '10px 14px 6px', borderBottom: '1px solid #e2e8f0' }}>
              {classesDisp.length > 1 && classesDisp.map(c => (
                <button key={c} onClick={() => { setClasseSel(c); setMarcados([]); }} style={btn(c === classeSel)}>Classe {c}</button>
              ))}
              {classesDisp.length > 1 && <span style={{ width: 1, height: 20, background: '#e2e8f0' }} />}
              <button onClick={() => setAba('livres')} style={btn(aba === 'livres')}>✅ Livres ({totalLivres})</button>
              <button onClick={() => setAba('ocupadas')} style={btn(aba === 'ocupadas')}>🚧 Ocupadas ({analise.itens.length - totalLivres})</button>
              <label style={{ fontSize: 12, color: '#374151', display: 'flex', alignItems: 'center', gap: 5, cursor: 'pointer', marginLeft: 4 }}>
                <input type="checkbox" checked={soVivas} onChange={e => { setSoVivas(e.target.checked); setMarcados([]); }} style={{ width: 'auto', margin: 0 }} />
                considerar só marcas vivas (Ativa / Em andamento)
              </label>
              <input value={filtro} onChange={e => setFiltro(e.target.value)} placeholder="🔎 filtrar itens (ex: ferragem, consultoria…)"
                style={{ ...inp, height: 28, width: 'auto', flex: '1 1 220px', minWidth: 180 }} />
            </div>
            <div style={{ padding: '4px 14px', fontSize: 11.5, color: '#6b7280', borderBottom: '1px solid #f1f5f9' }}>
              {titulo && <span><b>Classe {classeSel}</b> — {titulo}. </span>}
              {analise.semEspec > 0 && <span style={{ color: '#b45309' }}>⚠ {analise.semEspec} processo(s) sem especificação na base não entram na conta. </span>}
              Comparação por texto normalizado — igualdade do item ou contenção com 10+ caracteres. Redação livre pode não casar: confira a aba Ocupadas.
            </div>
            <div style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
              {!dados && <div style={{ padding: 24, color: '#6b7280', fontSize: 13 }}>Carregando a lista NCL…</div>}
              {dados && aba === 'livres' && (
                livres.length === 0
                  ? <div style={{ padding: 24, color: '#6b7280', fontSize: 13 }}>{f ? 'Nenhum item livre com esse filtro.' : 'Nenhum item livre — os processos do resultado cobrem a classe inteira.'}</div>
                  : livres.map(a => {
                    const on = marcados.includes(a.txt);
                    return (
                      <div key={a.txt} onClick={() => marcar(a.txt)} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', padding: '5px 14px', fontSize: 12.5, borderBottom: '1px solid #f1f5f9', cursor: 'pointer', background: on ? '#f0fdf4' : '#fff' }}>
                        <input type="checkbox" readOnly checked={on} style={{ width: 'auto', margin: '2px 0 0' }} />
                        <span style={{ color: '#111' }}>{destacar(a.txt, filtro)}</span>
                      </div>
                    );
                  })
              )}
              {dados && aba === 'ocupadas' && (
                ocupadas.length === 0
                  ? <div style={{ padding: 24, color: '#6b7280', fontSize: 13 }}>Nenhum item ocupado{f ? ' com esse filtro' : ''}.</div>
                  : ocupadas.map(a => (
                    <div key={a.txt} style={{ padding: '5px 14px', fontSize: 12.5, borderBottom: '1px solid #f1f5f9' }}>
                      <div style={{ color: '#111' }}>
                        {destacar(a.txt, filtro)}
                        {a.modo === 'contido' && <span title="Casou por contenção dentro de uma especificação maior, não item a item" style={{ marginLeft: 6, fontSize: 10, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 3, padding: '0 5px' }}>contido</span>}
                      </div>
                      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 3 }}>
                        {a.quem.map(r => {
                          const viva = r.situacao === 'Ativa' || r.situacao === 'Em andamento';
                          return (
                            <span key={r.numero} title={`proc. ${r.numero} · ${r.situacao || '—'}`} style={{ fontSize: 10.5, borderRadius: 3, padding: '1px 6px', background: viva ? '#fef2f2' : '#f3f4f6', color: viva ? '#991b1b' : '#6b7280', border: `1px solid ${viva ? '#fecaca' : '#e5e7eb'}` }}>
                              {r.nome_marca || '(figurativa)'} · {r.situacao || '—'}
                            </span>
                          );
                        })}
                      </div>
                    </div>
                  ))
              )}
            </div>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 14px', borderTop: '1px solid #e2e8f0', background: '#f8fafc' }}>
              <span style={{ fontSize: 12, color: '#6b7280', flex: 1 }}>
                {aba === 'livres' ? `${marcados.length} marcada(s) — clique no item para marcar` : 'Cada chip é um processo do resultado que lista o item'}
              </span>
              {aba === 'livres' && <button onClick={() => copiar(marcados, 'marcadas')} disabled={!marcados.length} style={{ ...btnCinza, opacity: marcados.length ? 1 : .5 }}>📋 Copiar marcadas ({marcados.length})</button>}
              {aba === 'livres' && <button onClick={() => copiar(livres.map(a => a.txt), 'todas as livres')} disabled={!livres.length} style={{ ...btnCinza, opacity: livres.length ? 1 : .5 }}>📋 Copiar todas as livres ({livres.length})</button>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// ── ⚖️ A marca pesquisada é desgastada? (16/09) ─────────────────────────────
// Manual 5.11.3: elemento desgastado = já faz parte de diversas marcas
// REGISTRADAS de DIFERENTES titulares no mesmo segmento. O backend conta os
// titulares distintos com marca ATIVA por elemento (e a expressão inteira, se
// a marca for composta) nas classes da pesquisa, e traz exemplos pra citar.
function ModalDesgaste({ onFechar, nome, classes }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const chaveClasses = (classes || []).join(',');

  useEffect(() => {
    const p = new URLSearchParams({ nome });
    if (chaveClasses) p.append('classes', chaveClasses);
    setDados(null); setErro('');
    fetch(`/marcas-rpi/desgaste?${p}`, { headers: { Authorization: `Bearer ${token()}` } })
      .then(async r => { const d = await r.json(); if (!r.ok) throw new Error(d.erro || 'Falha na análise'); return d; })
      .then(setDados).catch(e => setErro(e.message));
  }, [nome, chaveClasses]);

  const VEREDITO = {
    desgastada: ['DESGASTADA', '#b45309', '#fffbeb', '#fde68a'],
    parcial: ['PARCIALMENTE DESGASTADA', '#0369a1', '#f0f9ff', '#bae6fd'],
    nao: ['NÃO DESGASTADA', '#15803d', '#f0fdf4', '#86efac'],
  };
  const NIVEL = {
    desgastado: ['desgastado', '#b45309', '#fffbeb'],
    evocativo: ['evocativo', '#0369a1', '#f0f9ff'],
    forte: ['forte', '#15803d', '#f0fdf4'],
  };
  const fmtCl = (cl) => (cl && cl.length ? `cl. ${cl.join('/')}` : '');

  function copiarParaRecurso() {
    if (!dados) return;
    const cls = dados.classes_pesquisadas.length ? `na(s) classe(s) ${dados.classes_pesquisadas.join(', ')}` : 'na base do INPI (todas as classes)';
    const blocos = [...dados.termos.filter(t => t.nivel !== 'forte'), ...(dados.conjunto && dados.conjunto.nivel !== 'forte' ? [dados.conjunto] : [])]
      .map(t => `O elemento "${t.termo.toUpperCase()}" consta de ${t.marcas_ativas} marca(s) ativa(s) de ${t.titulares_ativos} titulares distintos ${cls}` +
        (t.exemplos.length ? `, entre elas: ${t.exemplos.slice(0, 8).map(e => `${e.nome_marca} (${e.titular}, proc. ${e.numero})`).join('; ')}.` : '.'));
    const texto = `Desgaste do signo (Manual de Marcas do INPI, item 5.11.3 — "Elementos desgastados"): ${dados.resumo}\n\n${blocos.join('\n\n')}\n\nNos termos do Manual, quando o elemento em comum já faz parte de diversas marcas registradas de diferentes titulares, o público-alvo está habituado à sua presença em marcas de diferentes fornecedores, de modo que a colidência só se caracteriza se a impressão de conjunto — gráfica, fonética ou ideológica — for semelhante à anterioridade.`;
    navigator.clipboard.writeText(texto).then(() => alert('✅ Texto copiado — pronto pra colar no recurso.')).catch(() => prompt('Copie abaixo:', texto));
  }

  const CartaoTermo = ({ t, rotulo }) => {
    const [nv, cor, bg] = NIVEL[t.nivel] || NIVEL.forte;
    return (
      <div style={{ border: '1px solid #e2e8f0', borderRadius: 6, padding: '10px 12px', marginBottom: 8 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          <span style={{ fontSize: 11, color: '#6b7280', textTransform: 'uppercase', letterSpacing: '.05em' }}>{rotulo}</span>
          <strong style={{ fontSize: 14, color: '#0a1628' }}>{t.termo.toUpperCase()}</strong>
          <span style={{ fontSize: 11, fontWeight: 700, color: cor, background: bg, border: `1px solid ${cor}44`, borderRadius: 3, padding: '1px 7px' }}>{nv}</span>
          {t.curto && <span style={{ fontSize: 11, color: '#6b7280' }}>termo com menos de 3 letras — não dá pra medir</span>}
        </div>
        {!t.curto && (
          <div style={{ fontSize: 12.5, color: '#374151', marginTop: 4 }}>
            <strong style={{ color: cor }}>{t.titulares_ativos}</strong> titulares distintos com marca <strong>ativa</strong> contendo o termo
            {' '}· {t.marcas_ativas} marca(s) ativa(s) · {t.titulares_total} titulares contando pendentes e mortas
          </div>
        )}
        {t.exemplos.length > 0 && (
          <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', marginTop: 6 }}>
            {t.exemplos.map(e => (
              <span key={e.numero} title={`proc. ${e.numero}${e.data_concessao ? ` · concedida em ${e.data_concessao}` : ''}`}
                style={{ fontSize: 10.5, borderRadius: 3, padding: '1px 7px', background: '#f8fafc', border: '1px solid #e2e8f0', color: '#374151' }}>
                <b>{e.nome_marca || '(figurativa)'}</b> — {e.titular}{e.classes && e.classes.length ? ` · ${fmtCl(e.classes)}` : ''}
              </span>
            ))}
            {t.titulares_ativos > t.exemplos.length && <span style={{ fontSize: 10.5, color: '#6b7280', alignSelf: 'center' }}>… e mais {t.titulares_ativos - t.exemplos.length} titulares</span>}
          </div>
        )}
      </div>
    );
  };

  const v = dados ? (VEREDITO[dados.veredito] || VEREDITO.nao) : null;
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, width: '100%', maxWidth: 900, maxHeight: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>
            ⚖️ A marca "{(nome || '').toUpperCase()}" é desgastada?
            <span style={{ fontWeight: 400, opacity: .65, fontSize: 12, marginLeft: 8 }}>
              {classes && classes.length ? `classe(s) ${classes.join(', ')}` : 'todas as classes'} · Manual de Marcas 5.11.3
            </span>
          </span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 14 }}>
          {erro && <div style={{ color: '#dc2626', fontSize: 13 }}>⚠ {erro}</div>}
          {!dados && !erro && <div style={{ color: '#6b7280', fontSize: 13 }}>Contando titulares na base da RPI…</div>}
          {dados && (
            <>
              <div style={{ background: v[2], border: `1px solid ${v[3]}`, borderRadius: 6, padding: '12px 14px', marginBottom: 12 }}>
                <div style={{ fontSize: 18, fontWeight: 800, color: v[1] }}>{v[0]}</div>
                <div style={{ fontSize: 13, color: '#111', marginTop: 4 }}>{dados.resumo}</div>
              </div>
              {!dados.classes_pesquisadas.length && (
                <div style={{ fontSize: 12, color: '#92400e', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 5, padding: '6px 10px', marginBottom: 10 }}>
                  ⚠ Pesquisa sem classe: a contagem é na base inteira. O Manual mede o desgaste <b>no segmento</b> — selecione a classe e pesquise de novo para o veredito valer.
                </div>
              )}
              {dados.termos.map(t => <CartaoTermo key={t.termo} t={t} rotulo={dados.termos.length > 1 ? 'elemento' : 'marca'} />)}
              {dados.conjunto && <CartaoTermo t={dados.conjunto} rotulo="expressão inteira" />}
              <div style={{ fontSize: 11.5, color: '#6b7280', marginTop: 10, lineHeight: 1.5 }}>
                <b>Como o veredito é dado.</b> O Manual (5.11.3) fala em "diversas marcas registradas de diferentes titulares" e não fixa número: aqui, {dados.criterio.desgastado}+ titulares distintos com marca <b>ativa</b> no segmento = desgastado; {dados.criterio.evocativo}–{dados.criterio.desgastado - 1} = evocativo; menos = forte. É calibração da Preserva, para o mesmo critério valer na pesquisa, no parecer e aqui. Amostra de até 5.000 marcas com o termo.
                {' '}<b>Efeito:</b> elemento desgastado não impede registro — a colidência passa a se decidir pelo <b>conjunto</b> (caso CLÍNICA ORTOPÉDICA DO RIO DE JANEIRO × HOSPITAL DAS CLÍNICAS DO RIO DE JANEIRO), e a marca nascida sobre ele tem proteção mais estreita.
              </div>
            </>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '8px 14px', borderTop: '1px solid #e2e8f0', background: '#f8fafc' }}>
          <span style={{ fontSize: 12, color: '#6b7280', flex: 1 }}>Passe o mouse no exemplo para ver o processo e a data de concessão.</span>
          <button onClick={copiarParaRecurso} disabled={!dados || dados.veredito === 'nao'} title={dados && dados.veredito === 'nao' ? 'Sem elemento desgastado pra argumentar' : 'Texto pronto com os exemplos, no formato de recurso'}
            style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap', opacity: dados && dados.veredito !== 'nao' ? 1 : .5 }}>
            📋 Copiar argumento para recurso
          </button>
        </div>
      </div>
    </div>
  );
}

function ModalEspecificacoesNcl({ onFechar, classesSel, toggleClasse }) {
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [classeSel, setClasseSel] = useState('1');
  const [filtroClasse, setFiltroClasse] = useState('');
  const [filtroSpec, setFiltroSpec] = useState('');
  const [marcados, setMarcados] = useState([]); // ["30|Açaí na tigela [...]"]

  useEffect(() => {
    fetch('/marcas-rpi/ncl', { headers: { Authorization: `Bearer ${token()}` } })
      .then(r => r.ok ? r.json() : Promise.reject(new Error('Especificações não disponíveis')))
      .then(setDados).catch(e => setErro(e.message));
  }, []);

  const numeros = dados ? Object.keys(dados).sort((a, b) => a - b) : [];
  const fc = normNcl(filtroClasse);
  // O filtro de classes procura no título E dentro das especificações — "veículo"
  // tem que achar a 35 (comércio de veículos) mesmo sem a palavra no título
  const contagemFc = {};
  const classesVisiveis = numeros.filter(n => {
    if (!fc) return true;
    if (normNcl(`classe ${n} ${dados[n].titulo}`).includes(fc)) return true;
    const q = dados[n].itens.reduce((s, txt) => s + (normNcl(txt).includes(fc) ? 1 : 0), 0);
    if (q > 0) { contagemFc[n] = q; return true; }
    return false;
  });

  // Como no site do INPI: o filtro da direita age só dentro da classe selecionada
  const fs = normNcl(filtroSpec);
  let itens = [];  // [{ n, txt }]
  if (dados && dados[classeSel]) {
    itens = dados[classeSel].itens
      .filter(txt => !fs || normNcl(txt).includes(fs))
      .map(txt => ({ n: classeSel, txt }));
  }
  const CAP = 500;
  const cortado = itens.length > CAP;

  const chave = it => `${it.n}|${it.txt}`;
  const marcar = it => setMarcados(prev => prev.includes(chave(it)) ? prev.filter(x => x !== chave(it)) : [...prev, chave(it)]);
  function copiarMarcados() {
    const texto = marcados.map(m => { const i = m.indexOf('|'); return `${m.slice(0, i)} - ${m.slice(i + 1)}`; }).join('\n');
    navigator.clipboard.writeText(texto).then(() => alert(`✅ ${marcados.length} especificação(ões) copiada(s).`))
      .catch(() => prompt('Copie abaixo:', texto));
  }

  const num2 = String(classeSel).padStart(2, '0');
  const painel = { flex: 1, minWidth: 280, display: 'flex', flexDirection: 'column', minHeight: 0 };
  const caixaBusca = { display: 'flex', gap: 6, marginBottom: 8 };
  const btnCinza = { background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', whiteSpace: 'nowrap' };

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 70, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 8, width: '100%', maxWidth: 1100, height: '88vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <div style={{ background: '#0a1628', padding: '10px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>Busca de Especificação de Produtos ou Serviços <span style={{ fontWeight: 400, opacity: .6, fontSize: 12 }}>— igual ao protocolo do INPI</span></span>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', lineHeight: 1 }}>×</button>
        </div>
        {erro && <div style={{ padding: 16, color: '#dc2626', fontSize: 13 }}>⚠ {erro}</div>}
        {!dados && !erro && <div style={{ padding: 24, color: '#6b7280', fontSize: 13 }}>Carregando as 45 classes…</div>}
        {dados && (
          <div style={{ flex: 1, display: 'flex', gap: 12, padding: 12, minHeight: 0, overflow: 'hidden' }}>
            {/* Painel esquerdo: classes */}
            <div style={painel}>
              <div style={caixaBusca}>
                <input placeholder="Digite um termo para filtrar" value={filtroClasse} onChange={e => setFiltroClasse(e.target.value)} style={{ ...inp, height: 28 }} />
                {filtroClasse && <button onClick={() => setFiltroClasse('')} style={btnCinza}>Limpar</button>}
              </div>
              <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 6, minHeight: 200 }}>
                {classesVisiveis.map(n => {
                  const ativa = n === classeSel;
                  return (
                    <div key={n} onClick={() => { setClasseSel(n); setFiltroSpec(contagemFc[n] ? filtroClasse : ''); }} title={dados[n].titulo}
                      style={{ padding: '7px 10px', fontSize: 12, cursor: 'pointer', borderBottom: '1px solid #f1f5f9',
                        background: ativa ? '#0a1628' : n % 2 ? '#fff' : '#fafafa', color: ativa ? '#fff' : '#374151',
                        display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                      <b>Classe {n}</b>{contagemFc[n] ? <span style={{ color: ativa ? '#7dd3fc' : '#1d4ed8', fontWeight: 700 }}> · {contagemFc[n]} item(ns)</span> : null} - {dados[n].titulo}
                    </div>
                  );
                })}
              </div>
            </div>
            {/* Painel direito: especificações */}
            <div style={painel}>
              <div style={caixaBusca}>
                <input placeholder="Digite um termo para filtrar" value={filtroSpec} onChange={e => setFiltroSpec(e.target.value)} style={{ ...inp, height: 28 }} />
                {filtroSpec && <button onClick={() => setFiltroSpec('')} style={btnCinza}>Limpar</button>}
              </div>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center', marginBottom: 8, flexWrap: 'wrap' }}>
                <span style={{ fontSize: 12, color: '#374151' }}><b>Classe {classeSel}</b> — {itens.length} especificações{fs ? ` com "${filtroSpec}"` : ''}</span>
                {toggleClasse && !classesSel.includes(num2) && classesSel.length < 3 && (
                  <button onClick={() => toggleClasse(num2)} style={{ ...btnCinza, background: '#f0fdf4', borderColor: '#86efac', color: '#166534', fontWeight: 700 }}>
                    ➕ Usar classe {classeSel} na pesquisa
                  </button>
                )}
                {classesSel.includes(num2) && <span style={{ fontSize: 11, color: '#166534', fontWeight: 700 }}>✓ na pesquisa</span>}
                {marcados.length > 0 && (
                  <button onClick={copiarMarcados} style={{ ...btnCinza, marginLeft: 'auto', background: '#0a1628', color: '#fff', borderColor: '#0a1628', fontWeight: 700 }}>
                    📋 Copiar marcadas ({marcados.length})
                  </button>
                )}
              </div>
              <div style={{ flex: 1, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 6, minHeight: 200 }}>
                {itens.slice(0, CAP).map((it, i) => (
                  <label key={i} style={{ display: 'flex', gap: 7, alignItems: 'flex-start', justifyContent: 'flex-start', textAlign: 'left', width: '100%', boxSizing: 'border-box', margin: 0, padding: '4px 10px', fontSize: 12.5, fontWeight: 400, color: '#374151', borderBottom: '1px solid #f8fafc', cursor: 'pointer', background: i % 2 ? '#fafafa' : '#fff' }}>
                    <input type="checkbox" checked={marcados.includes(chave(it))} onChange={() => marcar(it)} style={{ marginTop: 2, flexShrink: 0, width: 14, height: 14 }} />
                    <span style={{ flex: 1, textAlign: 'left' }}><b style={{ color: '#0a1628' }}>{it.n}</b> - {it.txt}</span>
                  </label>
                ))}
                {cortado && <div style={{ padding: 10, fontSize: 11.5, color: '#9ca3af' }}>Mostrando as {CAP} primeiras — refine o termo pra ver o resto.</div>}
                {itens.length === 0 && <div style={{ padding: 14, fontSize: 12, color: '#9ca3af' }}>Nenhuma especificação encontrada.</div>}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function PesquisaMarca() {
  const [aba, setAba] = useState('pesquisar');
  const [stats, setStats] = useState(null);

  const [subAba, setSubAba] = useState('marca');
  const [nclAberto, setNclAberto] = useState(false);
  const [livresAberto, setLivresAberto] = useState(false); // 🧩 especificações livres na classe
  const [desgasteAberto, setDesgasteAberto] = useState(false); // ⚖️ veredito de desgaste (Manual 5.11.3)
  const [nome, setNome] = useState('');
  const [gerandoParecer, setGerandoParecer] = useState(false);
  const [gerandoParecer2, setGerandoParecer2] = useState(false);

  // 2º parecer: mesmo endpoint com ?ramo= — o veredito muda conforme as
  // especificações das anterioridades protegerem ou não o ramo digitado
  async function baixarParecerRamo(nomeM, classesM, tipoM, ramoM) {
    if (gerandoParecer2) return;
    setGerandoParecer2(true);
    try {
      const url = `/marcas-rpi/parecer-viabilidade?nome=${encodeURIComponent(nomeM)}&classes=${encodeURIComponent(classesM.join(','))}&tipo=${tipoM}&ramo=${encodeURIComponent(ramoM)}`;
      const r = await fetch(url, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      if (!r.ok) {
        let det = '';
        try { det = (await r.json()).erro || ''; } catch { /* corpo não-JSON */ }
        return alert(`Falha ao gerar o 2º parecer (HTTP ${r.status}). ${det}`.trim());
      }
      const href = URL.createObjectURL(await r.blob());
      const a = document.createElement('a');
      a.href = href; a.download = `Parecer complementar — ${nomeM.trim().toUpperCase()} × ${ramoM.trim()}.pdf`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      URL.revokeObjectURL(href);
    } catch (err) {
      alert('Falha ao gerar o 2º parecer: ' + (err?.message || 'erro de rede'));
    } finally {
      setGerandoParecer2(false);
    }
  }
  const [tipoPesquisa, setTipoPesquisa] = useState('exata');
  // A busca que gerou o resultado na tela. O PDF e o cabeçalho usam ISTO, não
  // o formulário: mudar o rádio ou a classe sem pesquisar de novo não pode
  // mudar o parecer (foi assim que a WMODAS saiu "livre" na tela e "risco
  // médio" no PDF, em 16/09).
  const [ultimaBusca, setUltimaBusca] = useState(null);
  const buscaAtual = () => ultimaBusca || { nome: nome.trim(), classes, tipo: tipoPesquisa };
  const ROTULO_TIPO = { exata: 'Exata', radical: 'Radical', prefixo: 'Começa com', avancada: 'Avançada' };
  const formularioMudou = () => !!ultimaBusca && (
    ultimaBusca.tipo !== tipoPesquisa
    || ultimaBusca.nome !== nome.trim()
    || ultimaBusca.classes.join(',') !== classes.join(',')
  );
  const [classes, setClasses] = useState([]);
  // Qual linha está com a especificação aberta (clique na linha abre/fecha)
  const [espAberta, setEspAberta] = useState(null);
  // Busca dentro do que as anterioridades PROTEGEM, sem abrir uma a uma:
  // "Casa" na classe 35 traz dezenas — digitar "móveis" isola quem de fato
  // colide com o ramo do cliente.
  const [buscaEsp, setBuscaEsp] = useState('');
  // Filtro de situação da tabela: '' = todas · 'vivas' (Ativa + Em andamento,
  // as que bloqueiam) · ou uma situação exata ('Ativa', 'Em andamento', 'Inativa')
  const [filtroSit, setFiltroSit] = useState('');
  const [copiado, setCopiado] = useState(''); // número recém-copiado (feedback ✓)
  const copiarNumero = (num) => {
    const t = String(num || '');
    const feedback = () => { setCopiado(t); setTimeout(() => setCopiado(''), 1400); };
    if (navigator.clipboard) navigator.clipboard.writeText(t).then(feedback).catch(feedback);
    else { const el = document.createElement('textarea'); el.value = t; document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el); feedback(); }
  };
  const CelNumero = ({ num }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <span>{num}</span>
      {num && (
        <button onClick={e => { e.stopPropagation(); copiarNumero(num); }} title="Copiar número do processo"
          style={{ background: copiado === String(num) ? '#dcfce7' : '#f3f4f6', border: `1px solid ${copiado === String(num) ? '#86efac' : '#d1d5db'}`, borderRadius: 3, padding: '1px 5px', fontSize: 10, cursor: 'pointer', color: '#374151', lineHeight: 1, flexShrink: 0 }}>
          {copiado === String(num) ? '✓' : '📋'}
        </button>
      )}
    </div>
  );

  const [modalComp, setModalComp] = useState(false); // ⚖️ comparador de especificações

  // 🖨️ Impressão da pesquisa Básica: janela limpa com os dados do processo
  function imprimirBasica(res) {
    const p = res?.processo || {};
    const linhas = [['Marca', p.marca], ['Situação', p.situacao], ['Titular', p.titular], ['Procurador', p.procurador], ['Classe(s)', p.classes], ['Apresentação', p.apresentacao], ['Depósito', p.deposito], ['Concessão', p.concessao], ['Vigência', p.vencimento]]
      .map(([k, v]) => `<tr><td style="font-weight:700;padding:4px 10px;border:1px solid #ccc;white-space:nowrap">${k}</td><td style="padding:4px 10px;border:1px solid #ccc">${v || '—'}</td></tr>`).join('');
    const w = window.open('', '_blank');
    w.document.write(`<html><head><title>Processo ${p.numero || ''}</title></head><body style="font-family:Arial;padding:24px;color:#111">
      <h2 style="margin:0">Preserva Marcas® — Pesquisa de Processo</h2>
      <div style="color:#666;font-size:13px;margin:2px 0 14px">Processo ${p.numero || ''} · fonte: ${res?.fonte === 'rpi' ? 'Base local (RPI)' : 'INPI online'} · ${new Date().toLocaleString('pt-BR')}</div>
      <table style="border-collapse:collapse;font-size:14px">${linhas}</table></body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  }

  // Aba Básica: nº do processo OU nº da GRU
  const [numProc, setNumProc] = useState('');
  const [numGru, setNumGru] = useState('');
  const [resBasica, setResBasica] = useState(null);
  const [buscandoBasica, setBuscandoBasica] = useState(false);
  const [erroBasica, setErroBasica] = useState('');

  // Aba Titular: CNPJ/CPF OU nome do titular
  const [titDoc, setTitDoc] = useState('');
  const [titNome, setTitNome] = useState('');
  const [resTitular, setResTitular] = useState(null);
  const [buscandoTit, setBuscandoTit] = useState(false);
  const [erroTit, setErroTit] = useState('');
  const [infoTit, setInfoTit] = useState('');
  const [resultado, setResultado] = useState(null);
  const [buscando, setBuscando] = useState(false);
  const [erroBusca, setErroBusca] = useState('');

  const [arquivos, setArquivos] = useState([]);
  const [importando, setImportando] = useState(false);
  const [resultImport, setResultImport] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const inputRef = useRef();

  function toggleClasse(c) {
    setClasses(prev => {
      if (prev.includes(c)) return prev.filter(x => x !== c);
      if (prev.length >= 3) return prev;
      return [...prev, c];
    });
  }

  useEffect(() => { carregarStats(); }, []);

  async function carregarStats() {
    try {
      const res = await fetch('/marcas-rpi/stats', { headers: { Authorization: `Bearer ${token()}` } });
      const d = await res.json();
      setStats(d);
    } catch {}
  }

  async function pesquisar(e) {
    e.preventDefault();
    if (!nome.trim()) return;
    setBuscando(true);
    setErroBusca('');
    setResultado(null);
    try {
      const params = new URLSearchParams({ nome: nome.trim(), tipo: tipoPesquisa });
      if (classes.length > 0) params.append('classes', classes.join(','));
      const res = await fetch(`/marcas-rpi/pesquisar?${params}`, { headers: { Authorization: `Bearer ${token()}` } });
      const d = await res.json();
      if (!res.ok) throw new Error(d.erro);
      setResultado(d);
      setUltimaBusca({ nome: nome.trim(), classes: [...classes], tipo: tipoPesquisa });
    } catch (e) { setErroBusca(e.message); }
    finally { setBuscando(false); }
  }

  // Pesquisa Básica: processo consulta a base local (com fallback INPI online);
  // GRU é sempre INPI online (os XMLs da RPI não trazem número de GRU)
  async function pesquisarBasica(e) {
    e.preventDefault();
    const proc = numProc.replace(/\D/g, '');
    const gru = numGru.trim();
    if (!proc && !gru) return;
    setBuscandoBasica(true);
    setErroBasica('');
    setResBasica(null);
    try {
      const url = proc ? `/inpi/consultar/${proc}` : `/inpi/consultar-gru/${encodeURIComponent(gru)}`;
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token()}` } });
      const d = await res.json();
      if (!res.ok) throw new Error(d.mensagem || d.erro || 'Erro na consulta');
      if (!d.encontrado) setErroBasica(d.mensagem || 'Nada encontrado.');
      else setResBasica(d);
    } catch (e) { setErroBasica(e.message); }
    finally { setBuscandoBasica(false); }
  }

  // Pesquisa por Titular: nome busca direto na base local; CNPJ é resolvido
  // primeiro na Receita Federal (razão social) e então buscado pelo nome.
  // CPF não consta nos XMLs da RPI — sem fonte para resolver.
  async function pesquisarTitular(e) {
    e.preventDefault();
    const dig = titDoc.replace(/\D/g, '');
    let nomeBusca = titNome.trim();
    if (!dig && !nomeBusca) return;
    setBuscandoTit(true);
    setErroTit('');
    setInfoTit('');
    setResTitular(null);
    try {
      if (dig) {
        if (dig.length === 14) {
          const r = await fetch(`/clientes/consultar-cnpj/${dig}`, { headers: { Authorization: `Bearer ${token()}` } });
          const d = await r.json();
          if (!r.ok || !d.razao_social) throw new Error(d.erro || 'CNPJ não encontrado na Receita Federal.');
          nomeBusca = d.razao_social;
          setInfoTit(`CNPJ ${titDoc} → ${d.razao_social} (Receita Federal)`);
        } else if (dig.length === 11) {
          throw new Error('O CPF do titular não consta nos XMLs da RPI — pesquise pelo nome do titular.');
        } else {
          throw new Error('Documento inválido: informe um CNPJ (14 dígitos) ou CPF (11 dígitos).');
        }
      }
      if (!nomeBusca || nomeBusca.trim().length < 3) throw new Error('Informe ao menos 3 letras do nome do titular.');
      const res = await fetch(`/marcas-rpi/titular?nome=${encodeURIComponent(nomeBusca)}`, { headers: { Authorization: `Bearer ${token()}` } });
      const d = await res.json();
      if (!res.ok) throw new Error(d.erro);
      setResTitular(d.resultados || []);
    } catch (e) { setErroTit(e.message); }
    finally { setBuscandoTit(false); }
  }

  function onDrop(e) {
    e.preventDefault();
    setDragOver(false);
    const files = Array.from(e.dataTransfer.files).filter(f => f.name.endsWith('.xml'));
    setArquivos(prev => [...prev, ...files]);
  }

  // Importa UM ARQUIVO POR VEZ: se um falhar (queda de conexão/servidor),
  // só aquele se perde — e fica marcado em vermelho na lista, com botão de
  // reenviar só os que falharam. (Antes, um lote inteiro caía junto.)
  async function importar() {
    if (arquivos.length === 0) return;
    setImportando(true);
    setResultImport(null);
    const fila = [...arquivos].sort((a, b) => a.name.localeCompare(b.name, 'pt-BR', { numeric: true }));
    const porArquivo = fila.map(f => ({ nome: f.name, status: 'aguardando' }));
    let importados = 0, atualizados = 0, okCount = 0;
    setResultImport({ progresso: true, atual: 0, total: fila.length, porArquivo: [...porArquivo], importados, atualizados });
    const falharam = [];
    for (let i = 0; i < fila.length; i++) {
      porArquivo[i].status = 'enviando';
      setResultImport({ progresso: true, atual: i + 1, total: fila.length, porArquivo: [...porArquivo], importados, atualizados });
      try {
        const fd = new FormData();
        fd.append('xmls', fila[i]);
        const res = await fetch('/marcas-rpi/importar', { method: 'POST', headers: { Authorization: `Bearer ${token()}` }, body: fd });
        let d = {};
        try { d = await res.json(); } catch { d = { erros: [`HTTP ${res.status}`] }; }
        if (!res.ok || (d.erros && d.erros.length)) {
          porArquivo[i].status = 'erro';
          porArquivo[i].erro = (d.erros && d.erros[0]) || d.erro || `HTTP ${res.status}`;
          falharam.push(fila[i]);
        } else {
          porArquivo[i].status = 'ok';
          porArquivo[i].detalhe = `${(d.importados || 0).toLocaleString('pt-BR')} novas · ${(d.atualizados || 0).toLocaleString('pt-BR')} atualizadas`;
          importados += d.importados || 0;
          atualizados += d.atualizados || 0;
          okCount++;
        }
      } catch (e) {
        porArquivo[i].status = 'erro';
        porArquivo[i].erro = e.message;
        falharam.push(fila[i]);
      }
      setResultImport({ progresso: true, atual: i + 1, total: fila.length, porArquivo: [...porArquivo], importados, atualizados });
    }
    setResultImport({ progresso: false, total: fila.length, ok: okCount, falhas: falharam.length, porArquivo, importados, atualizados });
    setArquivos(falharam); // deixa só os que falharam prontos pra reenviar
    carregarStats();
    setImportando(false);
  }

  return (
    <div style={{ maxWidth: 1100 }}>
      {nclAberto && <ModalEspecificacoesNcl onFechar={() => setNclAberto(false)} classesSel={classes} toggleClasse={toggleClasse} />}
      <div style={{ marginBottom: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 8 }}>
        <div>
          <h1 style={{ fontSize: 17, fontWeight: 700, color: '#0a1628' }}>Pesquisa de Marca</h1>
          <p style={{ color: '#6b7280', fontSize: 12, marginTop: 1 }}>
            Base local de marcas extraída das RPIs importadas
            {stats && ` — ${stats.total.toLocaleString('pt-BR')} processos · ${stats.total_rpis} edições`}
          </p>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          {(localStorage.getItem('nomeUsuario') === 'Vagner Freitas' ? ['pesquisar', 'importar'] : ['pesquisar']).map(a => (
            <button key={a} onClick={() => setAba(a)}
              style={{ padding: '3px 12px', borderRadius: 4, border: '1px solid #0a1628', fontSize: 12, fontWeight: 600, cursor: 'pointer',
                background: aba === a ? '#0a1628' : '#fff', color: aba === a ? '#fff' : '#0a1628' }}>
              {a === 'pesquisar' ? 'Pesquisar' : 'Importar RPI'}
            </button>
          ))}
        </div>
      </div>

      {modalComp && <ComparadorEspecificacoes clienteInicial={(resBasica?.processo?.numero || numProc || '').replace(/\D/g, '')} onFechar={() => setModalComp(false)} />}
      {aba === 'pesquisar' && (
        <div>
          {/* Sub-abas da pesquisa (estilo INPI) — novas abas entram aqui */}
          <div style={{ display: 'flex', gap: 2, borderBottom: '2px solid #0a1628' }}>
            {[{ k: 'marca', l: 'Marca' }, { k: 'basica', l: 'Básica' }, { k: 'titular', l: 'Titular' }].map(t => (
              <button key={t.k} type="button" onClick={() => setSubAba(t.k)} style={{
                padding: '6px 24px', fontSize: 13, fontWeight: 700, border: 'none', cursor: 'pointer',
                borderRadius: '6px 6px 0 0',
                background: subAba === t.k ? '#0a1628' : '#e8edf2', color: subAba === t.k ? '#fff' : '#374151',
              }}>{t.l}</button>
            ))}
          </div>

          {subAba === 'marca' && (<>
          <div style={{ background: '#fff', borderRadius: '0 0 4px 4px', border: '1px solid #c8d0da', borderTop: 'none', padding: 14, marginBottom: 12 }}>
            <form onSubmit={pesquisar}>
              {/* Tipo de Pesquisa (estilo INPI) */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
                <div style={{ flex: '0 0 42%', background: '#ececec', padding: '5px 10px', textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#111', borderRadius: 2 }}>Tipo de Pesquisa:</div>
                <label style={{ fontSize: 13, color: '#111', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                  <input type="radio" name="tipoPesquisa" checked={tipoPesquisa === 'exata'} onChange={() => setTipoPesquisa('exata')} /> Exata
                </label>
                <label style={{ fontSize: 13, color: '#111', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                  <input type="radio" name="tipoPesquisa" checked={tipoPesquisa === 'radical'} onChange={() => setTipoPesquisa('radical')} /> Radical
                </label>
                <label style={{ fontSize: 13, color: '#111', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer', fontWeight: 700 }}>
                  <input type="radio" name="tipoPesquisa" checked={tipoPesquisa === 'avancada'} onChange={() => setTipoPesquisa('avancada')} /> Avançada
                </label>
                <label style={{ fontSize: 13, color: '#111', display: 'flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                  <input type="radio" name="tipoPesquisa" checked={tipoPesquisa === 'prefixo'} onChange={() => setTipoPesquisa('prefixo')} /> Começa com
                </label>
                <span title="Exata: grafia exatamente igual. Radical: o texto contido no nome, com acréscimo antes ou depois. Começa com: nomes que iniciam pelo texto. Avançada: tudo do Radical + fonética (KAZA acha CASA) + grafia quase idêntica por distância de letras (PETLUXO acha PETUXOS). Só a Avançada avalia som e grafia aproximada. O parecer em PDF sai exatamente da pesquisa feita, no tipo e nas classes escolhidas; a classe afim (35 ↔ produto) vai numa seção à parte." style={{ background: '#9ca3af', color: '#fff', width: 18, height: 18, borderRadius: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, cursor: 'help', flexShrink: 0 }}>?</span>
              </div>
              {/* Marca (estilo INPI) */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <div style={{ flex: '0 0 42%', background: '#ececec', padding: '5px 10px', textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#111', borderRadius: 2 }}>Marca:</div>
                <input value={nome} onChange={e => setNome(e.target.value)} placeholder="Ex: PRESERVA MARCAS"
                  style={{ ...inp, flex: 1, height: 30, border: '2px solid #2563eb', borderRadius: 4 }} />
                <button type="submit" disabled={buscando || !nome.trim()}
                  style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', height: 30 }}>
                  {buscando ? 'Buscando...' : 'Pesquisar'}
                </button>
                <button type="button" onClick={() => { setNome(''); setClasses([]); setResultado(null); setErroBusca(''); }}
                  style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer', height: 30 }}>
                  Limpar
                </button>
              </div>
              <div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  <label style={{ ...lbl, marginBottom: 0 }}>
                    Classe NCL — selecione até 3 {classes.length > 0 && <span style={{ color: '#0a1628' }}>({classes.length}/3)</span>}
                  </label>
                  <button type="button" onClick={() => setNclAberto(true)}
                    title="Abra a lista oficial de especificações de produtos e serviços de cada classe — igual à do protocolo do INPI — pra ter certeza de qual classe pesquisar"
                    style={{ background: '#eff6ff', border: '1px solid #bfdbfe', color: '#1d4ed8', borderRadius: 4, padding: '2px 10px', fontSize: 11.5, fontWeight: 700, cursor: 'pointer' }}>
                    📖 Especificações das classes
                  </button>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {CLASSES_NCL.map(c => {
                    const sel = classes.includes(c);
                    const bloq = !sel && classes.length >= 3;
                    return (
                      <button key={c} type="button" onClick={() => toggleClasse(c)} disabled={bloq}
                        style={{
                          padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: sel ? 700 : 400, cursor: bloq ? 'not-allowed' : 'pointer',
                          border: `1px solid ${sel ? '#0a1628' : '#c8d0da'}`,
                          background: sel ? '#0a1628' : '#fff', color: sel ? '#fff' : bloq ? '#d1d5db' : '#374151',
                        }}>
                        {c}
                      </button>
                    );
                  })}
                  {classes.length > 0 && (
                    <button type="button" onClick={() => setClasses([])}
                      style={{ padding: '2px 8px', borderRadius: 4, fontSize: 11, cursor: 'pointer', border: '1px solid #fca5a5', background: '#fee2e2', color: '#991b1b' }}>
                      Limpar classes
                    </button>
                  )}
                </div>
              </div>
            </form>
            {erroBusca && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 8 }}>⚠ {erroBusca}</div>}
          </div>

          {resultado && (
            <>
              <div style={{ ...semStyle[resultado.semaforo], borderRadius: 4, padding: '10px 14px', marginBottom: 10, display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 10, flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 13 }}>{resultado.semaforo_msg}</div>
                  <div style={{ fontSize: 12, marginTop: 1 }}>
                    {resultado.total} resultado(s) para "{buscaAtual().nome}" · pesquisa <strong>{ROTULO_TIPO[buscaAtual().tipo] || buscaAtual().tipo}</strong>
                    {buscaAtual().classes.length > 0 ? <> · classe(s) <strong>{buscaAtual().classes.join(', ')}</strong></> : ' · todas as classes'}
                  </div>
                  {formularioMudou() && (
                    <div style={{ fontSize: 11.5, marginTop: 4, padding: '4px 8px', borderRadius: 4, background: '#fffbeb', color: '#92400e', border: '1px solid #fde68a' }}>
                      ⚠ Você mudou o formulário depois de pesquisar. O resultado e o parecer continuam sendo da pesquisa acima — pesquise de novo para atualizar.
                    </div>
                  )}
                  {(resultado.detalhes || []).map((d, i) => (
                    <div key={i} style={{ fontSize: 11.5, marginTop: 2 }}>• {d}</div>
                  ))}
                </div>
                <a href={`/marcas-rpi/parecer-viabilidade?nome=${encodeURIComponent(buscaAtual().nome)}&classes=${encodeURIComponent(buscaAtual().classes.join(','))}&tipo=${buscaAtual().tipo}`}
                  onClick={async (e) => {
                    e.preventDefault();
                    if (gerandoParecer) return;
                    const href = e.currentTarget.href;
                    setGerandoParecer(true);
                    try {
                      const r = await fetch(href, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
                      if (!r.ok) {
                        let det = '';
                        try { det = (await r.json()).erro || ''; } catch { /* corpo não-JSON */ }
                        return alert(`Falha ao gerar o parecer (HTTP ${r.status}). ${det}`.trim());
                      }
                      const url = URL.createObjectURL(await r.blob());
                      const a = document.createElement('a');
                      a.href = url; a.download = `Parecer de viabilidade — ${buscaAtual().nome.toUpperCase()}.pdf`;
                      document.body.appendChild(a); a.click(); document.body.removeChild(a);
                      URL.revokeObjectURL(url);
                    } catch (err) {
                      alert('Falha ao gerar o parecer: ' + (err?.message || 'erro de rede'));
                    } finally {
                      setGerandoParecer(false);
                    }
                  }}
                  style={{ background: gerandoParecer ? '#64748b' : '#0a1628', color: '#fff', borderRadius: 5, padding: '6px 14px', fontSize: 12, fontWeight: 700, textDecoration: 'none', whiteSpace: 'nowrap', alignSelf: 'center', cursor: gerandoParecer ? 'wait' : 'pointer' }}>
                  {gerandoParecer ? '⏳ Gerando…' : '📄 Parecer (PDF)'}
                </a>
              </div>

              {resultado.resultados.length > 0 && (() => {
                const termo = normNcl(buscaEsp.trim());
                const bateSit = (r) => !filtroSit
                  || (filtroSit === 'vivas' ? (r.situacao === 'Ativa' || r.situacao === 'Em andamento') : r.situacao === filtroSit);
                const casa = (r) => (!termo || (r.classes || []).some(c => normNcl(c.especificacao || '').includes(termo))) && bateSit(r);
                const listaFiltrada = resultado.resultados.filter(casa);
                const nAtiva = resultado.resultados.filter(r => r.situacao === 'Ativa').length;
                const nAndamento = resultado.resultados.filter(r => r.situacao === 'Em andamento').length;
                const nInativa = resultado.resultados.filter(r => r.situacao === 'Inativa').length;
                return (
                <>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap', margin: '0 0 8px' }}>
                  <input value={buscaEsp} onChange={e => setBuscaEsp(e.target.value)}
                    placeholder="🔎 Buscar nas especificações (ex: móveis, consultoria, restaurante...)"
                    style={{ ...inp, width: 'auto', flex: '1 1 320px', minWidth: 240 }} />
                  <select value={filtroSit} onChange={e => setFiltroSit(e.target.value)}
                    title="Filtra a tabela pela coluna Situação — atenção: 'Em andamento' também bloqueia registro (anterioridade)"
                    style={{ background: filtroSit ? '#16a34a' : '#fff', color: filtroSit ? '#fff' : '#374151', border: `1px solid ${filtroSit ? '#16a34a' : '#d1d5db'}`, borderRadius: 4, padding: '4px 8px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    <option value="">Situação: todas ({resultado.resultados.length})</option>
                    <option value="vivas">🚧 Vivas — bloqueiam ({nAtiva + nAndamento})</option>
                    <option value="Ativa">✅ Só Ativa — registradas ({nAtiva})</option>
                    <option value="Em andamento">⏳ Só Em andamento ({nAndamento})</option>
                    <option value="Inativa">⚰️ Só Inativa — mortas ({nInativa})</option>
                  </select>
                  {/* Cruza as especificações dos processos listados com a NCL da classe */}
                  <button onClick={() => setLivresAberto(true)}
                    title="Mostra os itens da classe que nenhum processo deste resultado cobre — o que ainda dá pra pedir"
                    style={{ background: '#fff', border: '1px solid #0a1628', color: '#0a1628', borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    🧩 Livres na classe
                  </button>
                  {livresAberto && <ModalEspecificacoesLivres onFechar={() => setLivresAberto(false)} resultados={listaFiltrada} classesSel={buscaAtual().classes} />}
                  {/* A marca pesquisada é desgastada? (Manual 5.11.3 — titulares distintos com marca ativa no segmento) */}
                  <button onClick={() => setDesgasteAberto(true)}
                    title="Diz se a marca pesquisada é considerada desgastada: quantos titulares distintos têm marca ativa com cada elemento dela nas classes pesquisadas (Manual de Marcas 5.11.3)"
                    style={{ background: '#fff', border: '1px solid #b45309', color: '#b45309', borderRadius: 4, padding: '4px 10px', fontSize: 12, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap' }}>
                    ⚖️ Desgaste?
                  </button>
                  {desgasteAberto && <ModalDesgaste onFechar={() => setDesgasteAberto(false)} nome={buscaAtual().nome} classes={buscaAtual().classes} />}
                  {buscaEsp.trim() && (
                    <>
                      <span style={{ fontSize: 12, fontWeight: 700, color: listaFiltrada.length ? '#0a1628' : '#dc2626' }}>
                        {listaFiltrada.length} de {resultado.resultados.length} protegem algo com “{buscaEsp.trim()}”
                      </span>
                      <button onClick={() => setBuscaEsp('')}
                        style={{ background: '#fff', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 10px', fontSize: 12, cursor: 'pointer', color: '#374151' }}>× Limpar</button>
                      <button onClick={() => baixarParecerRamo(buscaAtual().nome, buscaAtual().classes, buscaAtual().tipo, buscaEsp.trim())} disabled={gerandoParecer2}
                        title="Parecer complementar: reavalia a viabilidade considerando se as anterioridades protegem ou não o ramo digitado"
                        style={{ background: gerandoParecer2 ? '#64748b' : (listaFiltrada.length ? '#d97706' : '#16a34a'), color: '#fff', border: 'none', borderRadius: 4, padding: '4px 12px', fontSize: 12, fontWeight: 700, cursor: gerandoParecer2 ? 'wait' : 'pointer' }}>
                        {gerandoParecer2 ? '⏳ Gerando…' : '📄 2º Parecer — análise do ramo (PDF)'}
                      </button>
                    </>
                  )}
                </div>
                {buscaEsp.trim() && listaFiltrada.length === 0 && (
                  <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#15803d', borderRadius: 4, padding: '8px 12px', fontSize: 12.5, marginBottom: 8 }}>
                    ✅ Nenhuma das {resultado.resultados.length} anterioridades protege “{buscaEsp.trim()}” — bom sinal para esse ramo específico.
                    <div style={{ color: '#166534', fontSize: 11.5, marginTop: 3 }}>
                      Atenção: a colidência no INPI considera afinidade entre atividades, não só a palavra exata. Isso reduz o risco, não elimina.
                    </div>
                  </div>
                )}
                <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={th}>Risco</th>
                        <th style={th}>Marca</th>
                        <th style={th}>Semelhança</th>
                        <th style={th}>Processo</th>
                        <th style={th}>Titular</th>
                        <th style={th}>UF</th>
                        <th style={th}>Classe(s)</th>
                        <th style={th}>Situação</th>
                        <th style={th}>Depósito</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaFiltrada.map((r, i) => {
                        const SIM = {
                          identica: ['Idêntica', '#dc2626', '#fef2f2'],
                          fonetica_identica: ['🔊 Fonética idêntica', '#dc2626', '#fef2f2'],
                          quase_identica: [`✏️ Grafia quase idêntica${r.radical_pct ? ` (${r.radical_pct}%)` : ''}`, '#dc2626', '#fef2f2'],
                          contem: ['Contém/contida', '#b45309', '#fffbeb'],
                          radical: ['Mesmo radical', '#b45309', '#fffbeb'],
                          fonetica: ['🔊 Fonética', '#0369a1', '#f0f9ff'],
                          parcial: ['Parcial', '#6b7280', '#f3f4f6'],
                        };
                        const [simTxt, simCor, simBg] = SIM[r.sim] || SIM.parcial;
                        const riscoCor = r.risco === 'alto' ? '#dc2626' : r.risco === 'medio' ? '#d97706' : '#16a34a';
                        const aberta = espAberta === r.numero;
                        const temEsp = (r.classes || []).some(c => (c.especificacao || '').trim());
                        return (
                        <React.Fragment key={i}>
                        <tr onClick={() => setEspAberta(aberta ? null : r.numero)}
                          title="Clique para ver o que esta marca protege (especificação)"
                          style={{ background: aberta ? '#f0f4ff' : (i % 2 === 0 ? '#fff' : '#fafafa'), cursor: 'pointer' }}>
                          <td style={td}>
                            <span style={{ display: 'inline-block', padding: '1px 8px', borderRadius: 4, fontSize: 10.5, fontWeight: 800, color: '#fff', background: riscoCor }}>
                              {r.risco === 'alto' ? 'ALTO' : r.risco === 'medio' ? 'MÉDIO' : 'baixo'}
                            </span>
                          </td>
                          <td style={{ ...td, fontWeight: 600, color: '#111' }}>
                            {r.nome_marca || <em style={{ color: '#9ca3af' }}>{r.apresentacao || '—'}</em>}
                            {r.apresentacao && <div style={{ fontSize: 10, color: '#9ca3af' }}>{r.apresentacao}</div>}
                          </td>
                          <td style={td}>
                            <span style={{ display: 'inline-block', padding: '1px 7px', borderRadius: 4, fontSize: 10.5, fontWeight: 700, color: simCor, background: simBg }}>{simTxt}</span>
                          </td>
                          <td style={td}><CelNumero num={r.numero} /></td>
                          <td style={{ ...td, maxWidth: 180 }}>{r.titular || '—'}</td>
                          <td style={td}>{r.uf || '—'}</td>
                          <td style={td}>{r.classes.map(c => c.codigo).join(', ')}{r.mesma_classe === true && <span title="Mesma classe pesquisada" style={{ color: '#dc2626', fontWeight: 800 }}> ●</span>}{r.mesma_classe === 'afim' && <span title="Classe AFIM (35↔produto): comércio do próprio produto também bloqueia — Manual 5.16" style={{ color: '#d97706', fontWeight: 800 }}> ◐</span>}</td>
                          <td style={td}>
                            <span style={{
                              display: 'inline-block', padding: '1px 7px', borderRadius: 4, fontSize: 11, fontWeight: 600,
                              background: r.situacao === 'Ativa' ? '#dcfce7' : r.situacao === 'Em andamento' ? '#fffbeb' : r.situacao === 'Inativa' ? '#fee2e2' : '#f3f4f6',
                              color: r.situacao === 'Ativa' ? '#15803d' : r.situacao === 'Em andamento' ? '#b45309' : r.situacao === 'Inativa' ? '#991b1b' : '#374151',
                            }} title={r.situacao === 'Em andamento' ? 'Pedido em exame — TAMBÉM bloqueia (anterioridade)' : ''}>{r.situacao}</span>
                            {r.caducavel && <span title="Concedida há 5+ anos: se não estiver em uso, pode ser atacada por caducidade (cód. 337) pra liberar o caminho — Manual 6.5" style={{ marginLeft: 4, cursor: 'help' }}>🎯</span>}
                          </td>
                          <td style={td}>{r.data_deposito || '—'}</td>
                        </tr>
                        {aberta && (
                          <tr>
                            <td colSpan={9} style={{ padding: '8px 14px', background: '#f8fafc', borderBottom: '2px solid #dbe2ea' }}>
                              <div style={{ fontSize: 11, fontWeight: 800, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 5 }}>
                                O que "{r.nome_marca || r.numero}" protege
                              </div>
                              {temEsp ? (r.classes || []).map((c, j) => (
                                <div key={j} style={{ marginBottom: 6 }}>
                                  <span style={{ fontSize: 11, fontWeight: 800, color: '#fff', background: '#0a1628', borderRadius: 4, padding: '1px 7px' }}>Classe {c.codigo}</span>
                                  {c.status && <span style={{ fontSize: 10.5, color: '#b45309', marginLeft: 6 }}>{c.status}</span>}
                                  <div style={{ fontSize: 12.5, color: '#374151', lineHeight: 1.55, marginTop: 3, whiteSpace: 'pre-wrap' }}>
                                    {(c.especificacao || '').trim()
                                      ? destacar(c.especificacao.trim(), buscaEsp)
                                      : <em style={{ color: '#9ca3af' }}>— especificação não informada nesta classe</em>}
                                  </div>
                                </div>
                              )) : (
                                <div style={{ fontSize: 12.5, color: '#9ca3af' }}>
                                  Especificação não veio na revista deste processo (comum em pedidos antigos ou de preenchimento livre) — confira no pePI antes de concluir.
                                </div>
                              )}
                              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 6, borderTop: '1px dashed #d1d5db', paddingTop: 5 }}>
                                ⚖️ Compare com o que o seu cliente vai proteger: a colidência se decide na especificação, não só na classe.
                              </div>
                            </td>
                          </tr>
                        )}
                        </React.Fragment>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
                </>
                );
              })()}
            </>
          )}
          </>)}

          {subAba === 'basica' && (
            <div style={{ background: '#fff', borderRadius: '0 0 4px 4px', border: '1px solid #c8d0da', borderTop: 'none', padding: 14, marginBottom: 12 }}>
              <form onSubmit={pesquisarBasica}>
                {/* Nº do Processo (estilo INPI) */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                  <div style={{ flex: '0 0 42%', background: '#ececec', padding: '5px 10px', textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#111', borderRadius: 2 }}>Nº do Processo:</div>
                  <input value={numProc} onChange={e => { setNumProc(e.target.value); if (e.target.value) setNumGru(''); }}
                    placeholder="Ex: 912345678" style={{ ...inp, flex: 1, height: 30, border: '2px solid #2563eb', borderRadius: 4 }} />
                  <span title="Busca instantânea na base local das RPIs; se o processo não constar, consulta o site do INPI." style={{ background: '#9ca3af', color: '#fff', width: 18, height: 18, borderRadius: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, cursor: 'help', flexShrink: 0 }}>?</span>
                </div>
                <div style={{ fontSize: 13, color: '#111', margin: '2px 0 6px' }}>ou</div>
                {/* Nº GRU (estilo INPI) */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                  <div style={{ flex: '0 0 42%', background: '#ececec', padding: '5px 10px', textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#111', borderRadius: 2 }}>Nº Guia de Recolhimento da União - GRU:</div>
                  <input value={numGru} onChange={e => { setNumGru(e.target.value); if (e.target.value) setNumProc(''); }}
                    placeholder="Ex: 29409161890574372" style={{ ...inp, flex: 1, height: 30, border: '2px solid #2563eb', borderRadius: 4 }} />
                  <span title="A GRU não consta nos XMLs da RPI — esta consulta é feita direto no site do INPI (pode levar até 1 minuto e depende do INPI estar no ar)." style={{ background: '#9ca3af', color: '#fff', width: 18, height: 18, borderRadius: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, cursor: 'help', flexShrink: 0 }}>?</span>
                </div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button type="button" onClick={() => setModalComp(true)}
                    title="Compara as especificações do processo do SEU CLIENTE com vários outros processos — mostra exatamente o que colide"
                    style={{ background: '#4c1d95', color: '#fff', padding: '4px 14px', borderRadius: 4, fontSize: 12, fontWeight: 700, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', height: 30 }}>
                    ⚖️ Comparação
                  </button>
                  <button type="submit" disabled={buscandoBasica || (!numProc.trim() && !numGru.trim())}
                    style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', height: 30 }}>
                    {buscandoBasica ? 'Consultando…' : 'Pesquisar'}
                  </button>
                  <button type="button" onClick={() => { setNumProc(''); setNumGru(''); setResBasica(null); setErroBasica(''); }}
                    style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer', height: 30 }}>
                    Limpar
                  </button>
                </div>
              </form>
              {buscandoBasica && numGru && <div style={{ fontSize: 12, color: '#6b7280', marginTop: 8 }}>Consultando o site do INPI — a busca por GRU pode levar até 1 minuto…</div>}
              {erroBasica && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 8 }}>⚠ {erroBasica}</div>}

              {resBasica?.processo && (
                <div style={{ marginTop: 14, border: '1px solid #c8d0da', borderRadius: 4 }}>
                  <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '4px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span>Processo {resBasica.processo.numero}</span>
                    <span style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                      <button type="button" onClick={() => imprimirBasica(resBasica)}
                        title="Imprimir esta pesquisa"
                        style={{ background: '#fff', color: '#0a1628', border: '1px solid #c8d0da', borderRadius: 4, padding: '1px 10px', fontSize: 11, fontWeight: 700, cursor: 'pointer', textTransform: 'none' }}>🖨️ Imprimir</button>
                      <span style={{ fontSize: 10, fontWeight: 600, background: resBasica.fonte === 'rpi' ? '#dcfce7' : '#dbeafe', color: resBasica.fonte === 'rpi' ? '#15803d' : '#1d4ed8', borderRadius: 4, padding: '1px 8px', textTransform: 'none' }}>
                        {resBasica.fonte === 'rpi' ? 'Base local (RPI)' : 'INPI online'}
                      </span>
                    </span>
                  </div>
                  <div style={{ padding: 12, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px 16px' }}>
                    {[
                      ['Marca', resBasica.processo.marca],
                      ['Situação', resBasica.processo.situacao],
                      ['Titular', resBasica.processo.titular],
                      ['Procurador', resBasica.processo.procurador],
                      ['Classe(s)', resBasica.processo.classes],
                      ['Apresentação', resBasica.processo.apresentacao],
                      ['Depósito', resBasica.processo.deposito],
                      ['Concessão', resBasica.processo.concessao],
                      ['Vigência', resBasica.processo.vencimento],
                    ].map(([k, v]) => (
                      <div key={k}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: '#6b7280', textTransform: 'uppercase' }}>{k}</div>
                        <div style={{ fontSize: 13, color: '#111' }}>{v || '—'}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {subAba === 'titular' && (
            <div style={{ background: '#fff', borderRadius: '0 0 4px 4px', border: '1px solid #c8d0da', borderTop: 'none', padding: 14, marginBottom: 12 }}>
              <form onSubmit={pesquisarTitular}>
                {/* CNPJ/CPF (estilo INPI) */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 4 }}>
                  <div style={{ flex: '0 0 42%', background: '#ececec', padding: '5px 10px', textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#111', borderRadius: 2 }}>CNPJ/CPF :</div>
                  <input value={titDoc} onChange={e => { setTitDoc(e.target.value); if (e.target.value) setTitNome(''); }}
                    placeholder="Ex: 00.000.000/0001-00" style={{ ...inp, flex: 1, height: 30, border: '2px solid #2563eb', borderRadius: 4 }} />
                  <span title="CNPJ: a razão social é identificada na Receita Federal e a busca é feita pelo nome na base das RPIs. CPF: não consta nos XMLs da RPI — use o nome." style={{ background: '#9ca3af', color: '#fff', width: 18, height: 18, borderRadius: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, cursor: 'help', flexShrink: 0 }}>?</span>
                </div>
                <div style={{ fontSize: 13, color: '#111', margin: '2px 0 6px' }}>ou</div>
                {/* Nome (estilo INPI) */}
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                  <div style={{ flex: '0 0 42%', background: '#ececec', padding: '5px 10px', textAlign: 'right', fontSize: 13, fontWeight: 600, color: '#111', borderRadius: 2 }}>Nome :</div>
                  <input value={titNome} onChange={e => { setTitNome(e.target.value); if (e.target.value) setTitDoc(''); }}
                    placeholder="Ex: LILIA DE ALMEIDA" style={{ ...inp, flex: 1, height: 30, borderRadius: 4 }} />
                  <span title="Busca o nome em qualquer posição, em todos os titulares do processo (base local das RPIs)." style={{ background: '#9ca3af', color: '#fff', width: 18, height: 18, borderRadius: 3, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, cursor: 'help', flexShrink: 0 }}>?</span>
                </div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <button type="submit" disabled={buscandoTit || (!titDoc.trim() && !titNome.trim())}
                    style={{ background: '#0a1628', color: '#fff', padding: '4px 14px', borderRadius: 4, fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', whiteSpace: 'nowrap', height: 30 }}>
                    {buscandoTit ? 'Buscando…' : 'Pesquisar'}
                  </button>
                  <button type="button" onClick={() => { setTitDoc(''); setTitNome(''); setResTitular(null); setErroTit(''); setInfoTit(''); }}
                    style={{ background: '#f3f4f6', color: '#374151', padding: '4px 12px', borderRadius: 4, fontSize: 12, border: '1px solid #d1d5db', cursor: 'pointer', height: 30 }}>
                    Limpar
                  </button>
                </div>
              </form>
              {infoTit && <div style={{ fontSize: 12, color: '#0369a1', marginTop: 8 }}>🏢 {infoTit}</div>}
              {erroTit && <div style={{ color: '#dc2626', fontSize: 12, marginTop: 8 }}>⚠ {erroTit}</div>}

              {resTitular && (
                <div style={{ marginTop: 14 }}>
                  <div style={{ fontSize: 12, color: '#374151', marginBottom: 6 }}><strong>{resTitular.length}</strong> processo(s) encontrado(s){resTitular.length === 100 ? ' (mostrando os 100 primeiros)' : ''}</div>
                  {resTitular.length > 0 && (
                    <div style={{ border: '1px solid #c8d0da', borderRadius: 4, overflowX: 'auto' }}>
                      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                          <tr>
                            <th style={th}>Marca</th>
                            <th style={th}>Processo</th>
                            <th style={th}>Titular</th>
                            <th style={th}>UF</th>
                            <th style={th}>Classe(s)</th>
                            <th style={th}>Situação</th>
                            <th style={th}>Depósito</th>
                          </tr>
                        </thead>
                        <tbody>
                          {resTitular.map((r, i) => (
                            <tr key={i} style={{ background: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                              <td style={{ ...td, fontWeight: 600, color: '#111' }}>{r.nome_marca || <em style={{ color: '#9ca3af' }}>{r.apresentacao || '—'}</em>}</td>
                              <td style={td}><CelNumero num={r.numero} /></td>
                              <td style={{ ...td, maxWidth: 220 }}>{r.titular || '—'}</td>
                              <td style={td}>{r.uf || '—'}</td>
                              <td style={td}>{(r.classes || []).map(c => c.codigo).join(', ')}</td>
                              <td style={td}>
                                <span style={{
                                  display: 'inline-block', padding: '1px 7px', borderRadius: 4, fontSize: 11, fontWeight: 600,
                                  background: r.situacao === 'Ativa' ? '#dcfce7' : r.situacao === 'Inativa' ? '#fee2e2' : '#f3f4f6',
                                  color: r.situacao === 'Ativa' ? '#15803d' : r.situacao === 'Inativa' ? '#991b1b' : '#374151',
                                }}>{r.situacao}</span>
                              </td>
                              <td style={td}>{r.data_deposito || '—'}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {/* Lista de RPIs importadas ocultada a pedido do usuário (2026-07-08) —
              a contagem segue no subtítulo e a lista completa na aba Importar RPI */}
        </div>
      )}

      {aba === 'importar' && (
        <div>
          <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: 14, marginBottom: 10 }}>
            <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 10 }}>
              Importar arquivos XML da RPI
            </div>
            <p style={{ fontSize: 12, color: '#6b7280', marginBottom: 12 }}>
              Selecione um ou vários arquivos XML da RPI. Você pode importar edições antigas para enriquecer a base.
            </p>

            <div onDragOver={e => { e.preventDefault(); setDragOver(true); }}
              onDragLeave={() => setDragOver(false)}
              onDrop={onDrop}
              onClick={() => inputRef.current.click()}
              style={{
                border: `2px dashed ${dragOver ? '#0a1628' : '#c8d0da'}`,
                borderRadius: 4, padding: 28, textAlign: 'center', cursor: 'pointer',
                background: dragOver ? '#f0f4ff' : '#fafafa', transition: 'all 0.15s',
              }}>
              <p style={{ fontSize: 13, fontWeight: 600, color: '#374151' }}>Arraste os arquivos XML aqui ou clique para selecionar</p>
              <p style={{ fontSize: 11, color: '#9ca3af', marginTop: 3 }}>Aceita múltiplos arquivos .xml</p>
              <input ref={inputRef} type="file" accept=".xml" multiple style={{ display: 'none' }}
                onChange={e => setArquivos(prev => [...prev, ...Array.from(e.target.files)])} />
            </div>

            {arquivos.length > 0 && (
              <div style={{ marginTop: 12 }}>
                <div style={{ fontSize: 12, fontWeight: 600, marginBottom: 6 }}>{arquivos.length} arquivo(s) selecionado(s):</div>
                <div style={{ maxHeight: 120, overflowY: 'auto', display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {arquivos.map((f, i) => (
                    <span key={i} style={{ background: '#f0f4ff', border: '1px solid #c7d2fe', borderRadius: 4, padding: '2px 8px', fontSize: 11, color: '#3730a3', display: 'flex', alignItems: 'center', gap: 4 }}>
                      {f.name}
                      <button onClick={e => { e.stopPropagation(); setArquivos(prev => prev.filter((_, j) => j !== i)); }}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6366f1', fontWeight: 700, fontSize: 13, padding: 0 }}>×</button>
                    </span>
                  ))}
                </div>
                <button onClick={importar} disabled={importando}
                  style={{ marginTop: 10, padding: '4px 16px', background: '#0a1628', color: '#fff', border: 'none', borderRadius: 4, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                  {importando ? 'Importando...' : `Importar ${arquivos.length} arquivo(s)`}
                </button>
              </div>
            )}
          </div>

          {resultImport && (
            <div style={{ background: '#fff', border: '1px solid #c8d0da', borderRadius: 4, padding: 14 }}>
              {resultImport.progresso ? (
                <>
                  <p style={{ color: '#0a1628', fontWeight: 700, fontSize: 13, marginBottom: 6 }}>
                    Importando arquivo {resultImport.atual} de {resultImport.total}…
                  </p>
                  <div style={{ height: 8, background: '#f3f4f6', borderRadius: 99, overflow: 'hidden', marginBottom: 10 }}>
                    <div style={{ width: `${Math.round((resultImport.atual / resultImport.total) * 100)}%`, height: '100%', background: '#0a1628', transition: 'width .3s' }} />
                  </div>
                </>
              ) : (
                <>
                  <p style={{ color: resultImport.falhas ? '#b45309' : '#15803d', fontWeight: 700, fontSize: 13, marginBottom: 8 }}>
                    {resultImport.falhas
                      ? `Importação concluída com falhas: ${resultImport.ok} OK · ${resultImport.falhas} falhou(aram) — os que falharam continuam na lista acima, clique em Importar para reenviar só eles.`
                      : 'Importação concluída — todos os arquivos entraram!'}
                  </p>
                  <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', marginBottom: 10 }}>
                    <div><span style={{ fontSize: 20, fontWeight: 700, color: '#0a1628' }}>{resultImport.total}</span><div style={{ fontSize: 11, color: '#6b7280' }}>Arquivos</div></div>
                    <div><span style={{ fontSize: 20, fontWeight: 700, color: '#15803d' }}>{(resultImport.importados || 0).toLocaleString('pt-BR')}</span><div style={{ fontSize: 11, color: '#6b7280' }}>Novos registros</div></div>
                    <div><span style={{ fontSize: 20, fontWeight: 700, color: '#0369a1' }}>{(resultImport.atualizados || 0).toLocaleString('pt-BR')}</span><div style={{ fontSize: 11, color: '#6b7280' }}>Atualizados</div></div>
                  </div>
                </>
              )}
              <div style={{ display: 'flex', flexDirection: 'column', gap: 3, maxHeight: 220, overflowY: 'auto' }}>
                {(resultImport.porArquivo || []).map((a, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, padding: '3px 8px', borderRadius: 4, background: a.status === 'erro' ? '#fee2e2' : a.status === 'ok' ? '#f0fdf4' : a.status === 'enviando' ? '#eff6ff' : '#fafafa' }}>
                    <span style={{ width: 16, textAlign: 'center' }}>{a.status === 'ok' ? '✓' : a.status === 'erro' ? '✗' : a.status === 'enviando' ? '⏳' : '·'}</span>
                    <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: '#111' }}>{a.nome}</span>
                    <span style={{ color: a.status === 'erro' ? '#991b1b' : '#6b7280', fontSize: 11 }}>{a.erro || a.detalhe || ''}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {stats && stats.total > 0 && (
            <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: 14, marginTop: 10 }}>
              <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px', fontSize: 12, fontWeight: 700, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 10 }}>
                Base atual
              </div>
              <div style={{ display: 'flex', gap: 24 }}>
                <div><span style={{ fontSize: 22, fontWeight: 700, color: '#0a1628' }}>{stats.total.toLocaleString('pt-BR')}</span><div style={{ fontSize: 11, color: '#6b7280' }}>Total de processos</div></div>
                <div><span style={{ fontSize: 22, fontWeight: 700, color: '#15803d' }}>{stats.ativas.toLocaleString('pt-BR')}</span><div style={{ fontSize: 11, color: '#6b7280' }}>Marcas ativas</div></div>
                <div><span style={{ fontSize: 22, fontWeight: 700, color: '#0369a1' }}>{stats.total_rpis}</span><div style={{ fontSize: 11, color: '#6b7280' }}>Edições da RPI</div></div>
              </div>
            </div>
          )}
        </div>
      )}
      <PesquisasDoSite />
    </div>
  );
}

// ── 🌐 Pesquisas feitas na página pública (inteligência de demanda) ─────────
// Só o Vagner enxerga (o backend devolve 403 pros demais e o painel some).
// Toda pesquisa do preserva.online/pesquisa fica registrada, vire lead ou não.
function PesquisasDoSite() {
  const [dados, setDados] = React.useState(null);
  const [aberto, setAberto] = React.useState(false);

  React.useEffect(() => {
    fetch('/marcas-rpi/pesquisas-site', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
      .then(r => r.ok ? r.json() : null)
      .then(setDados)
      .catch(() => {});
  }, []);

  if (!dados) return null;
  const SEM = { verde: '🟢', amarelo: '🟡', vermelho: '🔴' };
  const fmtDt = iso => iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)} ${new Date(new Date(iso).getTime() - 3 * 3600000).toISOString().slice(11, 16)}` : '';
  return (
    <div style={{ marginTop: 20, background: '#fff', border: '1px solid #c8d0da', borderRadius: 6, padding: '10px 14px' }}>
      <div onClick={() => setAberto(a => !a)} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}>
        <span style={{ fontSize: 13, fontWeight: 700, color: '#0a1628' }}>
          {aberto ? '▾' : '▸'} 🌐 Pesquisas do site público
        </span>
        <span style={{ fontSize: 12, color: '#6b7280' }}>
          <b style={{ color: '#1d4ed8' }}>{dados.hoje}</b> hoje · {dados.total} no total
        </span>
      </div>
      {aberto && (
        <div style={{ marginTop: 10, maxHeight: 320, overflowY: 'auto' }}>
          {dados.pesquisas.length === 0 ? (
            <div style={{ fontSize: 12.5, color: '#9ca3af', padding: '6px 0' }}>Nenhuma pesquisa ainda — divulga o preserva.online/pesquisa! 😉</div>
          ) : dados.pesquisas.map((p, i) => (
            <div key={i} style={{ display: 'flex', gap: 8, alignItems: 'center', padding: '4px 0', borderBottom: '1px solid #f1f5f9', fontSize: 12.5 }}>
              <span>{SEM[p.semaforo] || '⚪'}</span>
              <b style={{ color: '#0a1628', minWidth: 120 }}>{p.marca}</b>
              <span style={{ color: '#6b7280', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{p.ramo || '—'}</span>
              <span style={{ color: '#9ca3af', whiteSpace: 'nowrap' }}>{p.total} semelhantes</span>
              <span style={{ color: '#9ca3af', whiteSpace: 'nowrap' }}>{fmtDt(p.criado_em)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


// ── ⚖️ Comparador de especificações (12/08) ─────────────────────────────────
// O processo do CLIENTE contra vários outros: mostra exatamente quais
// especificações colidem — mesma classe é choque frontal (vermelho), classe
// diferente é afinidade (cinza). Fonte: base local das RPIs.
function ComparadorEspecificacoes({ clienteInicial, onFechar }) {
  const [cliente, setCliente] = useState(clienteInicial || '');
  const [outrosTxt, setOutrosTxt] = useState('');
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  async function comparar() {
    const outros = outrosTxt.split(/[\n,;\s]+/).map(t => t.replace(/\D/g, '')).filter(Boolean);
    if (!cliente.replace(/\D/g, '')) return setErro('Informe o processo do SEU cliente.');
    if (!outros.length) return setErro('Cole pelo menos um processo pra comparar (um por linha).');
    setErro(''); setCarregando(true); setDados(null);
    try {
      const r = await fetch('/marcas-rpi/comparar-especificacoes', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token()}` },
        body: JSON.stringify({ cliente, outros }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.erro || 'Erro na comparação');
      setDados(d);
    } catch (e) { setErro(e.message); }
    setCarregando(false);
  }

  function imprimir() {
    if (!dados) return;
    const c = dados.cliente;
    const blocos = dados.comparacoes.map(cp => cp.erro
      ? `<h3 style="margin:14px 0 4px">Processo ${cp.numero}</h3><div style="color:#991b1b">${cp.erro}</div>`
      : `<h3 style="margin:14px 0 4px">${cp.marca || '(sem nome)'} — ${cp.numero} <span style="font-weight:400;color:#666">(${cp.situacao || '—'} · classes ${cp.classes.join(', ') || '—'}${cp.classes_comuns.length ? ' · em comum: ' + cp.classes_comuns.join(', ') : ''})</span></h3>` +
        (cp.colisoes.length
          ? `<table style="border-collapse:collapse;font-size:12.5px;width:100%">` +
            cp.colisoes.map(col => `<tr><td style="border:1px solid #ccc;padding:3px 8px;white-space:nowrap;font-weight:700;color:${col.mesma_classe ? '#991b1b' : '#666'}">${col.mesma_classe ? 'MESMA CLASSE ' + col.classe_cliente : 'cl. ' + col.classe_cliente + ' × ' + col.classe_outro}</td><td style="border:1px solid #ccc;padding:3px 8px">${col.especificacao}${col.especificacao_outro ? ' <span style=\"color:#666\">(no outro: ' + col.especificacao_outro + ')</span>' : ''}</td></tr>`).join('') + `</table>`
          : `<div style="color:#15803d">Nenhuma especificação colidindo.</div>`));
    const w = window.open('', '_blank');
    w.document.write(`<html><head><title>Comparação de especificações</title></head><body style="font-family:Arial;padding:24px;color:#111">
      <h2 style="margin:0">Preserva Marcas® — Comparação de Especificações</h2>
      <div style="color:#666;font-size:13px;margin:2px 0 10px">Cliente: <b>${c.marca || ''}</b> (${c.numero}) · classes ${c.classes.join(', ')} · ${c.total_especificacoes} especificações · ${new Date().toLocaleString('pt-BR')}</div>
      ${(dados.especificacoes_livres || []).length
        ? `<div style="border:1px solid #86efac;background:#f0fdf4;border-radius:6px;padding:8px 12px;margin-bottom:10px"><b style="color:#15803d">✅ Sem colidência (${dados.especificacoes_livres.length} de ${c.total_especificacoes}):</b> ${dados.especificacoes_livres.map(e => `cl. ${e.classe} — ${e.especificacao}`).join(' · ')}</div>`
        : `<div style="border:1px solid #fca5a5;background:#fef2f2;border-radius:6px;padding:8px 12px;margin-bottom:10px;color:#991b1b;font-weight:700">⚠️ Todas as especificações do cliente colidem em pelo menos um dos processos comparados.</div>`}
      ${blocos.join('')}</body></html>`);
    w.document.close(); w.focus(); setTimeout(() => w.print(), 300);
  }

  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300, padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 10, width: 760, maxWidth: '96vw', maxHeight: '92vh', overflowY: 'auto', padding: 18 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10 }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: '#0a1628', flex: 1 }}>⚖️ Comparação de especificações</div>
          {dados && <button onClick={imprimir} style={{ background: '#fff', color: '#0a1628', border: '1px solid #c8d0da', borderRadius: 4, padding: '3px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>🖨️ Imprimir</button>}
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: 18, cursor: 'pointer', color: '#6b7280' }}>✕</button>
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
          <div style={{ minWidth: 200 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', display: 'block', marginBottom: 2 }}>Processo do SEU CLIENTE</label>
            <input value={cliente} onChange={e => setCliente(e.target.value)} placeholder="Ex.: 938114867" style={{ padding: '5px 10px', borderRadius: 4, border: '2px solid #4c1d95', fontSize: 13, width: 180 }} />
          </div>
          <div style={{ flex: 1, minWidth: 240 }}>
            <label style={{ fontSize: 11, fontWeight: 700, color: '#6b7280', display: 'block', marginBottom: 2 }}>Comparar com (um processo por linha — até 15)</label>
            <textarea value={outrosTxt} onChange={e => setOutrosTxt(e.target.value)} rows={3} placeholder={'913614971\n944218318\n…'}
              style={{ padding: '5px 10px', borderRadius: 4, border: '1px solid #b0b8c4', fontSize: 13, width: '100%', boxSizing: 'border-box', fontFamily: 'monospace' }} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 12 }}>
          <button onClick={comparar} disabled={carregando}
            style={{ background: '#4c1d95', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 18px', fontSize: 13, fontWeight: 700, cursor: 'pointer', opacity: carregando ? .6 : 1 }}>
            {carregando ? 'Comparando…' : 'Comparar'}
          </button>
          {erro && <span style={{ color: '#dc2626', fontSize: 12.5 }}>⚠ {erro}</span>}
        </div>

        {dados && (
          <>
            <div style={{ background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 6, padding: '8px 12px', fontSize: 12.5, marginBottom: 10 }}>
              Cliente: <b>{dados.cliente.marca || '(sem nome)'}</b> ({dados.cliente.numero}) · {dados.cliente.situacao || '—'} · classes {dados.cliente.classes.join(', ') || '—'} · {dados.cliente.total_especificacoes} especificações analisadas
            </div>
            {(dados.especificacoes_livres || []).length > 0 ? (
              <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '8px 12px', marginBottom: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 800, color: '#15803d', marginBottom: 4 }}>
                  ✅ Especificações do cliente SEM colidência ({dados.especificacoes_livres.length} de {dados.cliente.total_especificacoes}) — o espaço livre dele:
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {dados.especificacoes_livres.map((e, i) => (
                    <span key={i} style={{ fontSize: 11.5, background: '#fff', border: '1px solid #bbf7d0', color: '#166534', borderRadius: 10, padding: '2px 10px' }}>
                      cl. {e.classe} · {e.especificacao}
                    </span>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 6, padding: '8px 12px', fontSize: 12, fontWeight: 700, color: '#991b1b', marginBottom: 10 }}>
                ⚠️ TODAS as especificações do cliente colidem em pelo menos um dos processos comparados — nenhum espaço livre.
              </div>
            )}
            {dados.comparacoes.map(cp => (
              <div key={cp.numero} style={{ border: '1px solid #dbe2ea', borderRadius: 8, marginBottom: 10, overflow: 'hidden' }}>
                <div style={{ background: '#0a1628', color: '#fff', padding: '6px 12px', fontSize: 12.5, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <b>{cp.erro ? `Processo ${cp.numero}` : cp.marca || '(sem nome)'}</b>
                  {!cp.erro && <span style={{ color: '#94a3b8' }}>{cp.numero} · {cp.situacao || '—'} · classes {cp.classes.join(', ') || '—'}</span>}
                  {!cp.erro && cp.classes_comuns.length > 0 && <span style={{ background: '#fee2e2', color: '#991b1b', borderRadius: 8, padding: '0 8px', fontSize: 10.5, fontWeight: 700 }}>classe em comum: {cp.classes_comuns.join(', ')}</span>}
                  {!cp.erro && <span style={{ marginLeft: 'auto', fontWeight: 800, color: cp.colisoes.length ? '#fca5a5' : '#86efac' }}>{cp.colisoes.length ? `${cp.colisoes.length} colisão(ões)` : 'sem colisão'}</span>}
                </div>
                {cp.erro ? (
                  <div style={{ padding: '8px 12px', fontSize: 12.5, color: '#991b1b' }}>⚠ {cp.erro}</div>
                ) : cp.colisoes.length === 0 ? (
                  <div style={{ padding: '8px 12px', fontSize: 12.5, color: '#15803d' }}>Nenhuma especificação do seu cliente aparece neste processo. ✅</div>
                ) : (
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <tbody>
                      {cp.colisoes.map((col, i) => (
                        <tr key={i} style={{ background: i % 2 ? '#fafafa' : '#fff', borderBottom: '1px solid #f0f0f0' }}>
                          <td style={{ padding: '4px 10px', whiteSpace: 'nowrap', width: 130 }}>
                            <span style={{ fontSize: 10.5, fontWeight: 800, borderRadius: 4, padding: '1px 8px', background: col.mesma_classe ? '#fee2e2' : '#f3f4f6', color: col.mesma_classe ? '#991b1b' : '#6b7280' }}>
                              {col.mesma_classe ? `MESMA CLASSE ${col.classe_cliente}` : `cl. ${col.classe_cliente} × ${col.classe_outro}`}
                            </span>
                          </td>
                          <td style={{ padding: '4px 10px', color: '#111' }}>
                            {col.especificacao}
                            {col.especificacao_outro && <span style={{ color: '#6b7280' }}> — no outro: “{col.especificacao_outro}”</span>}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            ))}
            <div style={{ fontSize: 11, color: '#9ca3af' }}>Colisão = especificação igual ou contida (Manual 5.11) na base local das RPIs. MESMA CLASSE em processo vivo é o risco frontal; classe diferente indica afinidade mercadológica.</div>
          </>
        )}
      </div>
    </div>
  );
}
